import { render, staticRenderFns } from "./UnusedSchool.vue?vue&type=template&id=747c2ff2&"
import script from "./UnusedSchool.vue?vue&type=script&lang=js&"
export * from "./UnusedSchool.vue?vue&type=script&lang=js&"
import style0 from "./UnusedSchool.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports